import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';

interface IProjectMemberEntity {
	id: string;
	name: string;
	isAdmin: boolean;
	avatar: AvatarEntity;
}

const entityDefaults: IProjectMemberEntity = {
	id: '',
	name: '',
	isAdmin: false,
	avatar: AvatarEntity.build('user'),
};

export class ProjectMemberEntity implements IProjectMemberEntity {
	public id = entityDefaults.id;
	public name = entityDefaults.name;
	public isAdmin = entityDefaults.isAdmin;
	public avatar = entityDefaults.avatar;

	public static build(
		params: Partial<IProjectMemberEntity> = {}
	): ProjectMemberEntity {
		const instance = new ProjectMemberEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.name = params.name ?? entityDefaults.name;
		instance.isAdmin = params.isAdmin ?? entityDefaults.isAdmin;
		if (params.name) {
			instance.avatar = AvatarEntity.build(params.name);
		}
		return instance;
	}
}
